import { forwardRef } from "react";

import { withSubComponents } from "../../utilities/withSubComponents";
import { InputBaseProps } from "../InputBaseProps";
import { RefComponent } from "../RefComponent";
import { Placeholder } from "../TextArea/Placeholder";
import { Field } from "./Field";
import { Input } from "./Input";
import { SharedProps } from "./SharedProps";

/**
 * The `CodeArea` component properties.
 */

export interface CodeAreaProps extends InputBaseProps<string | null>, SharedProps {
  /**
   * The unique identifier for the CodeArea component. This is used to associate the label and instructions with the textarea for accessibility purposes.
   */
  readonly id?: string;
}

/**
 * The `CodeArea` component sub components.
 */
export interface CodeAreaSubComponents {
  /**
   * A React Hook Form compatible CodeArea Field component. For more information, see the documentation for
   * the <a href="https://react-hook-form.com/api">React Hook Form API</a>.
   */
  readonly Field: typeof Field;

  /**
   * A placeholder component for the CodeArea which can be displayed while loading.
   */
  readonly Placeholder: typeof Placeholder;
}

/**
 * An input component which allows the user to enter a code or other formatted content.
 */
export const CodeArea = withSubComponents<RefComponent<HTMLTextAreaElement, CodeAreaProps>, CodeAreaSubComponents>(
  {
    Field,
    Placeholder,
  },
  forwardRef<HTMLTextAreaElement, CodeAreaProps>(function CodeArea(props, ref) {
    return <Input {...props} ref={ref} />;
  }),
);
